import {
  SubstitutionPartsParamsType,
  SubstitutionPartsResponseType,
} from '@/common/queries/selections/substitutionParts/substitutionParts.type';
import { fetchApi } from '@/config/axiosSetting';

export const substitutionPartsFunction = (
  param: SubstitutionPartsParamsType,
): Promise<SubstitutionPartsResponseType[]> => {
  return fetchApi.get('/selection_item/damaged_points/wop_list/', {
    params: { name: param?.name, insurance: param.insurance },
  });
};
